/**
 * install.js — "Add to home screen" support.
 *
 * Chrome/Edge on Android and desktop fire `beforeinstallprompt`; we keep the
 * event so the Help sheet can offer a real "Install app" button. iOS Safari
 * never fires it — there the Help sheet shows the Share → Add to Home Screen
 * steps instead. Imported once from main.jsx so the event is never missed.
 */
let deferredPrompt = null
const listeners = new Set()
const notify = () => listeners.forEach((fn) => fn())

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault()
    deferredPrompt = event
    notify()
  })
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null
    notify()
  })
}

export function subscribeInstall(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function canPromptInstall() {
  return !!deferredPrompt
}

export async function promptInstall() {
  if (!deferredPrompt) return false
  const event = deferredPrompt
  deferredPrompt = null
  event.prompt()
  const { outcome } = await event.userChoice
  notify()
  return outcome === 'accepted'
}

export function isStandalone() {
  return window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true
}

export function isIOS() {
  const ua = window.navigator.userAgent || ''
  return /iPad|iPhone|iPod/.test(ua) || (ua.includes('Mac') && 'ontouchend' in document)
}
